var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogmaGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 36,
    viewBox: "0 0 186 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9883_33053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9883_33053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 186,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 0H0V35.7506H186V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9883_33053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9883_33053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 186,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186 0H0V35.7506H186V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9883_33053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0535 13.0012V16.2506C13.0535 18.0439 11.5915 19.5 9.79104 19.5C7.99056 19.5 6.5286 18.0439 6.5286 16.2506C6.5286 14.4574 7.99428 13.0012 9.79104 13.0012H13.0535ZM13.0535 0V6.49877H9.79104C4.39332 6.49877 0 10.8745 0 16.2506C0 21.6268 4.39332 26.0025 9.79104 26.0025C15.1888 26.0025 19.5821 21.6268 19.5821 16.2506V13.0012H13.0572L19.5821 6.50248V0H13.0572H13.0535Z",
    fill: "currentColor"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5786 0H13.0537V6.49877H19.5786V0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9883_33053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 186,
    height: 36
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186 0H0V35.7506H186V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9883_33053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4561 13.001C28.6556 13.001 27.1936 14.4571 27.1936 16.2504C27.1936 18.0437 28.6556 19.4998 30.4561 19.4998C32.2566 19.4998 33.7185 18.0437 33.7185 16.2504C33.7185 14.4571 32.2566 13.001 30.4561 13.001ZM30.4561 26.0023C25.0584 26.0023 20.665 21.6302 20.665 16.2504C20.665 10.8706 25.0546 6.49854 30.4561 6.49854C35.8575 6.49854 40.2471 10.8743 40.2471 16.2504C40.2471 21.6265 35.8538 26.0023 30.4561 26.0023Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.124 13.001C49.3236 13.001 47.8616 14.4571 47.8616 16.2504C47.8616 18.0437 49.3236 19.4998 51.124 19.4998C52.9245 19.4998 54.3865 18.0437 54.3865 16.2504V13.001H51.124ZM51.124 26.0023C45.7263 26.0023 41.333 21.6302 41.333 16.2504C41.333 10.8706 45.7263 6.49854 51.124 6.49854H60.9151V16.2504C60.9151 21.6265 56.5218 26.0023 51.124 26.0023Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.124 35.7504C45.7263 35.7504 41.333 31.3784 41.333 25.9985H47.8579C47.8579 27.7918 49.3198 29.2479 51.1203 29.2479C52.9208 29.2479 54.3828 27.7918 54.3828 25.9985H60.9076C60.9076 31.3747 56.5143 35.7504 51.1166 35.7504",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6332 26.0023H88.1083V16.2504C88.1083 14.4571 86.6463 13.001 84.8459 13.001C83.0454 13.001 81.5834 14.4571 81.5834 16.2504V26.0023H75.0585V16.2504C75.0585 14.4571 73.5966 13.001 71.7961 13.001C69.9956 13.001 68.5337 14.4571 68.5337 16.2504V26.0023H62.0088V16.2504C62.0088 10.8743 66.4021 6.49854 71.7998 6.49854C74.3034 6.49854 76.5949 7.43963 78.3247 8.98837C80.0582 7.43963 82.346 6.49854 84.8496 6.49854C90.2473 6.49854 94.6406 10.8743 94.6406 16.2504V26.0023H94.6332Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.511 13.001C103.71 13.001 102.248 14.4571 102.248 16.2504C102.248 18.0437 103.71 19.4998 105.511 19.4998H108.773V16.2504C108.773 14.4571 107.311 13.001 105.511 13.001ZM115.302 26.0023H105.511C100.113 26.0023 95.7197 21.6302 95.7197 16.2504C95.7197 10.8706 100.109 6.49854 105.511 6.49854C110.912 6.49854 115.302 10.8743 115.302 16.2504V26.0023Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.632 16.2506C123.832 16.2506 122.37 17.7067 122.37 19.4999C122.37 21.2932 123.832 22.7493 125.632 22.7493C127.433 22.7493 128.895 21.2932 128.895 19.4999V16.2506H125.632ZM125.632 26.0024C122.031 26.0024 119.107 23.0865 119.107 19.5037C119.107 15.9208 122.035 13.0049 125.632 13.0049H132.157V19.5037C132.157 23.0902 129.23 26.0024 125.632 26.0024Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.632 32.501C122.031 32.501 119.107 29.5851 119.107 26.0022H122.37C122.37 27.7955 123.832 29.2516 125.632 29.2516C127.433 29.2516 128.895 27.7955 128.895 26.0022V13.001H132.157V26.0022C132.157 29.5888 129.23 32.501 125.632 32.501Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.595 26.0022H134.333V18.5253C134.333 15.4797 136.822 13.001 139.88 13.001H142.491V16.2504H139.88C138.618 16.2504 137.595 17.2693 137.595 18.5253V26.0022Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21 22.7491H179.472C181.273 22.7491 182.735 21.293 182.735 19.4997C182.735 17.7065 181.273 16.2504 179.472 16.2504C177.672 16.2504 176.21 17.7065 176.21 19.4997V22.7491ZM176.21 32.501H172.947V19.4997C172.947 15.9169 175.875 13.001 179.472 13.001C183.069 13.001 185.997 15.9169 185.997 19.4997C185.997 23.0826 183.069 25.9985 179.472 25.9985H176.21V32.4973V32.501Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.106 16.2506C148.305 16.2506 146.843 17.7067 146.843 19.4999C146.843 21.2932 148.305 22.7493 150.106 22.7493C151.906 22.7493 153.368 21.2932 153.368 19.4999C153.368 17.7067 151.906 16.2506 150.106 16.2506ZM150.106 26.0024C146.505 26.0024 143.581 23.0865 143.581 19.5037C143.581 15.9208 146.509 13.0049 150.106 13.0049C153.703 13.0049 156.631 15.9208 156.631 19.5037C156.631 23.0865 153.703 26.0024 150.106 26.0024Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.789 26.0024C161.188 26.0024 158.264 23.0865 158.264 19.5037V13.0049H161.526V19.5037C161.526 21.2969 162.988 22.753 164.789 22.753C166.589 22.753 168.051 21.2969 168.051 19.5037V13.0049H171.313V19.5037C171.313 23.0902 168.386 26.0024 164.789 26.0024Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9883_33053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 35.7506,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogmaGroupLogo);
export default __webpack_public_path__ + "static/media/dogma-group-logo.c943b300a3375aa4e7f2cb85c384f2c1.svg";
export { ForwardRef as ReactComponent };